import { render, staticRenderFns } from "./ModalMoreMenuDetailProject.vue?vue&type=template&id=5e5903cb&scoped=true"
import script from "./ModalMoreMenuDetailProject.vue?vue&type=script&lang=js"
export * from "./ModalMoreMenuDetailProject.vue?vue&type=script&lang=js"
import style0 from "./ModalMoreMenuDetailProject.vue?vue&type=style&index=0&id=5e5903cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5903cb",
  null
  
)

export default component.exports